function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Box, Button, Dialog, Flex, Notice, Text, useToasts } from '@applyboard/crystal-ui';
import { CircleCrossHifiIcon } from '@applyboard/ui-icons';
import { useEventTracker, useTrackViewEvent } from '@applyboard/ui-utils';
import { ApplicationActionName } from "../../../../types";
import { useApplication, useApplicationAvailableActions, useLegacyApplicationRequirements, useUpdateApplication, useLegacyApplication, ProgramType } from "../../data";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var RPSelfEvaluation = function RPSelfEvaluation(_ref) {
  var _legacyApplication$sc, _legacyApplication$sc2;
  var _onSuccess = _ref.onSuccess;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useApplicationAvaila = useApplicationAvailableActions(),
    canPerformApplicationAction = _useApplicationAvaila.canPerformApplicationAction;
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var _useUpdateApplication = useUpdateApplication(),
    updateApplication = _useUpdateApplication.updateApplication,
    isUpdatingApplication = _useUpdateApplication.isUpdatingApplication;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDialogOpen = _useState2[0],
    setIsDialogOpen = _useState2[1];
  var toasts = useToasts();

  // TODO: Replace use of legacy application information as much as possible after https://applyboard.atlassian.net/browse/AWA-4576
  var academicProgram = legacyApplication === null || legacyApplication === void 0 ? void 0 : legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Main;
  });
  var eslProgram = legacyApplication === null || legacyApplication === void 0 ? void 0 : legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  var commonEventData = {
    applicationNanoId: application === null || application === void 0 ? void 0 : application.id,
    studentId: application === null || application === void 0 ? void 0 : application.student.id,
    mainIntake: academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.intake.startDate,
    eslIntake: eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate,
    programId: academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.programId,
    programLevel: academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.programLevel,
    schoolId: (_legacyApplication$sc = legacyApplication.school) === null || _legacyApplication$sc === void 0 ? void 0 : _legacyApplication$sc.id,
    schoolCountry: (_legacyApplication$sc2 = legacyApplication.school) === null || _legacyApplication$sc2 === void 0 ? void 0 : _legacyApplication$sc2.countryCode
  };
  var _useEventTracker = useEventTracker({
      data: commonEventData
    }),
    trackEvent = _useEventTracker.trackEvent;
  var onConfirm = function onConfirm(_ref2) {
    var modalType = _ref2.modalType;
    updateApplication({
      processingInformation: {
        stageId: 'submission'
      }
    }, {
      onSuccess: function () {
        var _onSuccess2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                trackEvent({
                  event: 'Single Application - RP Self Evaluation - Confirmed Making Application Ready To Submit',
                  data: {
                    modalType: modalType
                  }
                });
                toasts.positive('Application status is successfully changed to “Ready to Submit”. Please monitor the Applicant Requirements tab for any new requirements.');
                _onSuccess();
                setIsDialogOpen(false);
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function onSuccess() {
          return _onSuccess2.apply(this, arguments);
        }
        return onSuccess;
      }(),
      onError: function onError(error) {
        setIsDialogOpen(false);
        if (error instanceof Error) {
          toasts.negative(error);
        }
      }
    });
  };
  return legacyApplication && canPerformApplicationAction(ApplicationActionName.STAGE_CHANGE_SUBMISSION) ? _jsx(RPSelfEvaluationNotification, {
    isDialogOpen: isDialogOpen,
    setIsDialogOpen: setIsDialogOpen,
    onConfirm: onConfirm,
    commonEventData: commonEventData,
    isUpdating: isUpdatingApplication,
    trackEvent: trackEvent,
    applicationId: application.id
  }) : _jsx(_Fragment, {});
};
var RPSelfEvaluationNotification = function RPSelfEvaluationNotification(_ref3) {
  var isDialogOpen = _ref3.isDialogOpen,
    setIsDialogOpen = _ref3.setIsDialogOpen,
    _onConfirm = _ref3.onConfirm,
    commonEventData = _ref3.commonEventData,
    isUpdating = _ref3.isUpdating,
    trackEvent = _ref3.trackEvent;
  var _useLegacyApplication2 = useLegacyApplicationRequirements(),
    applicationRequirements = _useLegacyApplication2.applicationRequirements;
  useTrackViewEvent({
    event: 'Single Application - RP Self Evaluation',
    data: commonEventData
  });
  var isStudentProfileMismatch = applicationRequirements.some(function (applicationRequirement) {
    return applicationRequirement.attachments.some(function (attachment) {
      return attachment.automatedVerificationResults.some(function (verificationResult) {
        return verificationResult.resultCode === 'name_not_match';
      });
    });
  });
  var hasMissingRequirement = applicationRequirements.some(function (applicationRequirement) {
    return applicationRequirement.status === 'status_missing';
  });
  var modalType = getModalType({
    isStudentProfileMismatch: isStudentProfileMismatch,
    hasMissingRequirement: hasMissingRequirement
  });
  var onOpenChange = function onOpenChange(_ref4) {
    var open = _ref4.open,
      ignoreEvent = _ref4.ignoreEvent;
    if (!open && !ignoreEvent) {
      trackEvent({
        event: 'Single Application - RP Self Evaluation - Clicked Cancel OR Clicked OR X',
        data: {
          modalType: modalType
        }
      });
    }
    setIsDialogOpen(open);
  };
  return _jsxs(_Fragment, {
    children: [_jsx(Box, {
      pb: 2,
      pr: 2,
      children: _jsxs(Notice, {
        intent: "secondary",
        children: ["Congratulations! Based on having a great record, you are eligible to move this application to the next step. Just click \u201CReady to submit\u201D once the student has all the necessary documents and meets the criteria.", _jsx(Notice.Button, {
          onClick: function onClick() {
            setIsDialogOpen(!isDialogOpen);
            trackEvent({
              event: 'Single Application - RP Self Evaluation - Confirmation Modal Opened',
              data: _objectSpread({
                modalType: modalType
              }, getRequirementCounts(applicationRequirements))
            });
          },
          children: "Ready to submit"
        })]
      })
    }), hasMissingRequirement ? _jsx(CannotSubmitDialog, {
      open: isDialogOpen,
      onOpenChange: onOpenChange
    }) : _jsx(ConfirmSubmitDialog, {
      open: isDialogOpen,
      onOpenChange: onOpenChange,
      isStudentProfileMismatch: isStudentProfileMismatch,
      isUpdating: isUpdating,
      onConfirm: function onConfirm() {
        return _onConfirm({
          modalType: modalType
        });
      }
    })]
  });
};
function getRequirementCounts(applicationRequirements) {
  return {
    requirementsMissingCount: applicationRequirements.filter(function (requirement) {
      return requirement.status === 'status_missing';
    }).length,
    requirementsNotApprovedCount: applicationRequirements.filter(function (requirement) {
      return requirement.status === 'status_not_approved';
    }).length,
    requirementsCompletedCount: applicationRequirements.filter(function (requirement) {
      return requirement.status === 'status_completed';
    }).length,
    totalRequirementsCount: applicationRequirements.length ? applicationRequirements.length : 0
  };
}
function getModalType(_ref5) {
  var isStudentProfileMismatch = _ref5.isStudentProfileMismatch,
    hasMissingRequirement = _ref5.hasMissingRequirement;
  if (hasMissingRequirement) {
    return 'Cannot proceed';
  }
  if (isStudentProfileMismatch) {
    return 'Warnings can proceed';
  }
  return 'No warnings can proceed';
}
var CannotSubmitDialog = function CannotSubmitDialog(_ref6) {
  var open = _ref6.open,
    _onOpenChange = _ref6.onOpenChange;
  return _jsxs(Dialog, {
    open: open,
    onOpenChange: function onOpenChange(open) {
      return _onOpenChange({
        open: open
      });
    },
    children: [_jsx(Dialog.Heading, {
      children: "Cannot Make Application Ready to Submit"
    }), _jsx(Dialog.Content, {
      children: _jsxs(Flex, {
        direction: "row",
        gap: 4,
        children: [_jsx(Flex.Item, {
          children: _jsx(CircleCrossHifiIcon, {
            intent: "negative"
          })
        }), _jsx(Flex.Item, {
          children: _jsxs(Flex, {
            direction: "column",
            gap: 4,
            children: [_jsx(Text, {
              intent: "secondary",
              variant: "bodyM",
              children: "Unfortunately, the application cannot be made \u201CReady to Submit\u201D, since one or more requirements are in \u201CMissing\u201D state."
            }), _jsx(Text, {
              intent: "secondary",
              variant: "bodyM",
              children: "Please provide all required information for all the missing requirements and try again."
            })]
          })
        })]
      })
    }), _jsx(Dialog.Actions, {
      children: _jsx(Button, {
        intent: "primary",
        width: "fill",
        onClick: function onClick() {
          _onOpenChange({
            open: false,
            ignoreEvent: true
          });
        },
        children: "OK"
      })
    })]
  });
};
var ConfirmSubmitDialog = function ConfirmSubmitDialog(_ref7) {
  var open = _ref7.open,
    _onOpenChange2 = _ref7.onOpenChange,
    isStudentProfileMismatch = _ref7.isStudentProfileMismatch,
    onConfirm = _ref7.onConfirm,
    isUpdating = _ref7.isUpdating;
  return _jsxs(Dialog, {
    open: open,
    onOpenChange: function onOpenChange(open) {
      return _onOpenChange2({
        open: open
      });
    },
    children: [_jsx(Dialog.Heading, {
      children: "Make Application Ready to Submit?"
    }), _jsx(Dialog.Content, {
      children: _jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [isStudentProfileMismatch && _jsx(Notice, {
          intent: "warning",
          children: "One or more uploaded files contain data that doesn't match with the student profile. We recommend fixing the issue(s) before moving forward with the application."
        }), _jsx(Text, {
          intent: "secondary",
          variant: "bodyM",
          children: "Making the application \u201CReady to Submit\u201D will automatically approve all information provided and mark all requirements as \u201CComplete\u201D. Once confirmed, you will not be able to modify them."
        }), _jsx(Text, {
          intent: "secondary",
          variant: "bodyM",
          children: "Please confirm that you want to make this application \u201CReady to Submit\u201D."
        })]
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: "Cancel"
      }), _jsx(Button, {
        intent: "primary",
        disabled: isUpdating,
        loading: isUpdating,
        width: "fill",
        onClick: onConfirm,
        children: "Confirm"
      })]
    })]
  });
};